module.exports = __webpack_public_path__ + "images/government_exhibit_room.png";